import { render, staticRenderFns } from "./addressBooks.vue?vue&type=template&id=1d5e2651&scoped=true"
import script from "./addressBooks.vue?vue&type=script&lang=ts"
export * from "./addressBooks.vue?vue&type=script&lang=ts"
import style0 from "./addressBooks.vue?vue&type=style&index=0&id=1d5e2651&prod&scoped=true&lang=scss"
import style1 from "./addressBooks.vue?vue&type=style&index=1&id=1d5e2651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e2651",
  null
  
)

export default component.exports